/* WizardExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");

class WizardExplorerLmrbComponent extends GameEditor {
    constructor(logger, di, editorLayout, WizardEntity, solutionManager) {
        super(logger, di);
        this._WizardEntityDefinition = WizardEntity;
        this._editorLayout = editorLayout;
        this._solutionManager = solutionManager;

        this.setNamespaceGlobs([Registrations.WIZARD_EXPLORER_LMRB + ".**"], true);

        this._registerWizardListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerWizardListeners() {
        this._solutionManager.on("activeSolutionChanged", (this._onSolutionChanged = this._onSolutionChanged.bind(this)));
    }
    _unregisterWizardListeners() {
        this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterWizardListeners();
        return super.shutdown().then(() => {
            this._renderer = undefined;
            this._editorLayout = undefined;
            this._solutionManager = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     !newActiveSolution.lmrbNamespaces ||
        //     !newActiveSolution.lmrbNamespaces.includes(Registrations.WIZARD_EXPLORER_LMRB)
        // ) {
        this.shutdown();
        // }
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get WizardEntityDefinition() {
        return this.getWizardEntityDefinition();
    }
    getWizardEntityDefinition() {
        return this._WizardEntityDefinition;
    }
    get filterProperties() {
        return this.getFilterProperties();
    }
    getFilterProperties() {
        return this._WizardEntityDefinition.$filterProperties;
    }
    launchWizardEditor(editorState, launchOpts) {
        return this._editorLayout.launchEditor(editorState, Registrations.WIZARD_INSTANCE_EDITOR, launchOpts);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = WizardExplorerLmrbComponent;
WizardExplorerLmrbComponent.$inject = ["$teve.logger", "$teve.di", "EditorLayout.EditorLayout", "$teve.entities.Wizard", "$teve.solutionsManager"];
WizardExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
WizardExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
WizardExplorerLmrbComponent.$iconRepoName = "wizard.wizardExplorer";
WizardExplorerLmrbComponent.$openedByDefault = true;
WizardExplorerLmrbComponent.$displayName = "Workflow Explorer";
